import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import '../index.scss';

const validateStaffLogin = (data,zenotiAccount) => {
  const errors = {};

  if (!data.username) {
    errors.username = {
      message: 'Please enter a username',
    };
  }

  if (!data.password) {
    errors.password = {
      message: 'Please enter a password',
    };
  }

  if (!zenotiAccount){
    errors.zenotiAccount = {
      message: 'Please enter a password',
    };
  }

  return errors;
};

export default class BookerAccountInfo extends React.Component {
  constructor(props) {
    super(props);

    // const { business } = this.props;

    this.state = {
      zenotiAccount: '',
      ZenotiAPIKey: '',
      username: '',
      password: '',
      errors: {},
      mandatoryFieldError: false,
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.onNextButtonClick = this.onNextButtonClick.bind(this);
    this.validate = this.validate.bind(this);
  }

  onInputChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }
  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }
  componentDidMount(){
    const { softwares } = this.props;
    const { zenotiData, form , LOGIN , PASSWORD} = softwares;
    console.log('LOGIN 1',form , LOGIN , PASSWORD, this.state);
    this.setState({
      ...((zenotiData.account || form.account_name) && {zenotiAccount: form.account_name?form.account_name:zenotiData.account}),
      ...((zenotiData.apiKey || form.api_key) && {ZenotiAPIKey: form.api_key?form.api_key:zenotiData.apiKey}),
      ...((zenotiData.username || LOGIN) && {username: zenotiData.username?zenotiData.username:LOGIN}),
      ...((zenotiData.password || PASSWORD) && {password: zenotiData.password?zenotiData.password:PASSWORD}),
    });
  }
  componentWillUnmount(){
    console.log('Unmount state reset 2');
  }

  onNextButtonClick() {
    const { zenotiAccount, ZenotiAPIKey } = this.state;
    const { zenotiAuthType } = this.props;
    if(zenotiAuthType !== 'STAFF_LOGIN'){
      const data = {
        account: zenotiAccount,
        apiKey: ZenotiAPIKey || '',
        client: 'ZENOTI',
      };
      this.props.storeZentiData(data);
      const validationResult = this.validate(data,zenotiAuthType);
      const skipdata = {
        skip:true
      };
      this.props.postStaffLogin(skipdata);
      console.log('3',data);
      if (validationResult) {
        this.props.postZenotiAccountInfo(data);
        console.log('2',data);
      }
    }else{
      const data = {
        username: this.state.username,
        password: this.state.password,
      };
      const validationErrors = validateStaffLogin(data,zenotiAccount);
      if (Object.keys(validationErrors).length && zenotiAuthType === 'STAFF_LOGIN') {
        this.setState({
          errors: validationErrors,
          mandatoryFieldError: true,
        });
      } else {
        this.setState(
          {
            errors: {},
            mandatoryFieldError: false,
          },
          () => {
            this.props.postZenotiAccountInfo({
              account: zenotiAccount,
              apiKey: ZenotiAPIKey || '',
              client: 'ZENOTI',
            });
            this.props.storeZentiData({
            ...data,
            account: zenotiAccount,
            apiKey: ZenotiAPIKey || '',
            client: 'ZENOTI',
            })
            this.props.postStaffLogin(data);
            console.log('1',data);
          },
        );
        }
    }
  }

  validate(data, zenotiAuthType) {
    if (zenotiAuthType == 'API_KEY' && (!data.apiKey || !data.account) ) {
      this.setState({
        mandatoryFieldError: true,
      });

      return false;
    }else if(zenotiAuthType == 'STAFF_LOGIN' && this.state.username?.trim() && !this.state.password?.trim()){
      this.setState({
        mandatoryFieldError: true,
      });

      return false;
    }

    this.setState({
      mandatoryFieldError: false,
    });

    return true;
  }

  render() {
    const { zenotiAccount, ZenotiAPIKey, mandatoryFieldError,credType, errors,username, password } = this.state;
    const { softwares, zenotiAuthType, onzenotiAuthTypeChange , dashboard} = this.props;
    const { info, form } = softwares;
    const isSwConnected = dashboard.tasksStatus.bookingSW_connect === 'completed';
    console.log('STATE',isSwConnected, info, form);
    return (
      <div className="authorize-access">
        <form className="authorize-access__form">
          {mandatoryFieldError ? (
            <p className="authorize-access__error">
              <i className="fa fa-exclamation-circle" aria-hidden="true" />
              Fields marked in red are mandatory!
            </p>
          ) : null}
          {softwares.isBookerAccountInfoSaveFail ? (
            <p className="authorize-access__error">
              <i className="fa fa-exclamation-circle" aria-hidden="true" />
              Unable to save account information
            </p>
          ) : null}
          
          <div className="authorize-access__form__row form-group">
            <p className="form-group__heading">Please select type of credential for Authorization</p>
            <div className="radio-group">
            <div className="radio-input">
            <input
              type="radio"
              name="credType"
              className={classnames({ 'has-error': mandatoryFieldError })}
              value='STAFF_LOGIN'
              checked={zenotiAuthType==='STAFF_LOGIN'}
              onChange={()=>onzenotiAuthTypeChange('STAFF_LOGIN')}
              autoComplete="false"
            />
             <label className="form-group__label">Staff Credentials</label> 
             </div>
            <div className="radio-input">
            <input
              type="radio"
              name="credType"
              className={classnames({ 'has-error': mandatoryFieldError })}
              value='API_KEY'
              checked={zenotiAuthType==='API_KEY'}
              onChange={()=>onzenotiAuthTypeChange('API_KEY')}
              autoComplete="false"
            />
             <label className="form-group__label">API key</label>
             </div>
             </div>
          </div>


          <div className="authorize-access__form__row form-group">
            <p className="form-group__heading">Enter your Zenoti Account Name &#42;</p>
            <input
              type="text"
              name="zenotiAccount"
              className={classnames({ 'has-error': (mandatoryFieldError ||  errors.zenotiAccount)})}
              value={zenotiAccount}
              onChange={this.onInputChange}
              disabled={isSwConnected}
              autoComplete="false"
            />
          </div>
          <p className="authorize-access_hint">
                  Hint: Your Zenoti Account Name is the same as the leading
                  part of the URL for your Zenoti online account
          </p>

          <div className="authorize-access__form__row form-group">
            <p className="form-group__heading">Enter a unique Zenoti API Key {zenotiAuthType==='STAFF_LOGIN'?'(not mandatory)':''}</p>
            <input
              type="text"
              name="ZenotiAPIKey"
              className={classnames({ 'has-error': (mandatoryFieldError && zenotiAuthType === 'API_KEY') })}
              value={ZenotiAPIKey}
              onChange={this.onInputChange}
              autoComplete="false"
            />
          </div>

          <p className="authorize-access_hint">
            Hint: You can find instrutions on how to generate an API key by going to the
            following link and referring to the Overview section.
            <a className="authorize-access__help-text" href="https://docs.zenoti.com/?version=latest#intro" target="_blank">
                  https://docs.zenoti.com/?version=latest#intro
            </a>
          </p>

          <section className="authorize-access__sw-details">
            <p className="authorize-access__heading">
              Please create a staff login on your Zenoti software for TrueLark to use and enter
              those here
            </p>
            <div className="authorize-access__form__row form-group">
              <p className="form-group__heading">Username</p>
              <input
                type="text"
                name="username"
                className={classnames({
                  'has-error': errors.username,
                })}
                value={username}
                onChange={this.onInputChange}
                autoComplete="false"
                placeholder="Username"
                //disabled={isSwConnected}
              />
            </div>

            <div className="authorize-access__form__row form-group">
              <p className="form-group__heading">Password</p>
              <input
                type="text"
                name="password"
                className={classnames({
                  'has-error': errors.password,
                })}
                value={password}
                onChange={this.onInputChange}
                autoComplete="false"
                placeholder="password"
                //disabled={isSwConnected}
              />
            </div>
          </section>
        </form>
        <div className="authorize-access__actions">
          <button className="btn btn--secondary btn--lg" type="button" onClick={this.props.onBackClick}>
            Previous
          </button>
          <button
            className="btn btn--primary btn--lg"
            onClick={this.onNextButtonClick}
            disabled={softwares.isSavingBookerAccountInfo}
          >
            {!softwares.isSavingBookerAccountInfo ? 'Next' : 'Saving...'}
          </button>
        </div>
      </div>
    );
  }
}

BookerAccountInfo.defaultProps = {
  postZenotiAccountInfo: () => {},
  onBackClick: () => {},
};

BookerAccountInfo.propTypes = {
  postZenotiAccountInfo: PropTypes.func,
  onBackClick: PropTypes.func,
  softwares: PropTypes.shape().isRequired,
};
